import { Component, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { HasRoleDirective } from '../../../core/directives/has-role.directive';
import { StorageService } from '../../../core/services/storage.service';

@Component({
    selector: 'sidebar-menu',
    imports: [
        RouterLink,
        RouterLinkActive,
        HasRoleDirective
    ],
    templateUrl: './sidebar-menu.component.html',
    styleUrl: './sidebar-menu.component.scss'
})
export class SidebarMenuComponent implements OnInit {

  username: string = '';
  institution: string = '';

  constructor(private router: Router, private tokenManager: StorageService) {}

  ngOnInit() {
    const jwt = this.tokenManager.getToken();
    if (jwt) {
      this.username = jwt.sub;
      this.institution = jwt.institution;
    }
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh');
    this.router.navigateByUrl('/login').finally();
  }
}
